"use client";

export function CurrentYear() {
  return <>{new Date().getFullYear()}</>;
}
